import React from "react";
import { PageHero, PageBody, STATIC_CONTENT, renderInstituteHtml } from "./_shared";
import { useFood } from "./FoodLayout";
import { Sprout, Target, Compass } from "lucide-react";

export default function About() {
  const data = useFood();
  const trust = data.trust || {};
  return (
    <div data-testid="ft-about">
      <PageHero
        eyebrow="Our Story"
        title="A new chapter in food technology education"
        subtitle="Built on the academic legacy of GS Mandal, MIT College of Food Technology was created to answer a need: India's food industry deserves graduates who think like scientists and ship like engineers."
      />
      <PageBody>
        {/* GSM strip */}
        <div className="bg-white rounded-lg shadow-md border-l-4 border-[#F4751F] p-8 mb-10">
          <div className="flex items-start gap-5 flex-wrap">
            {trust.logo_url && (
              <img src={trust.logo_url} alt="GSM" className="w-24 h-24 rounded-md object-contain bg-[#FCFAF4] ring-1 ring-[#E6E2D6] p-2" />
            )}
            <div className="flex-1 min-w-[260px]">
              <h2 className="font-serif text-2xl text-[#1F6B3F]">{trust.trust_name || "Gramaudyogik Shikshan Mandal (GSM)"}</h2>
              {trust.registration_number && (
                <div className="mt-1 text-[10px] uppercase tracking-[0.2em] text-[#C95507] font-semibold">Reg. No · {trust.registration_number}</div>
              )}
              <p className="mt-3 text-sm text-[#4D5A52] leading-relaxed">
                Established in 1975, GS Mandal is a multi-institution trust whose mission is rural-industrial education in Marathwada. The Mandal&apos;s portfolio spans engineering, polytechnic, science &amp; technology, and food technology — with thousands of alumni serving across India and abroad.
              </p>
            </div>
          </div>
        </div>

        {/* About + Vision + Mission */}
        <div className="grid md:grid-cols-3 gap-5">
          <div className="md:col-span-2 bg-white rounded-lg shadow-md p-7 border-t-4 border-[#1F6B3F]">
            <Sprout className="text-[#1F6B3F]" size={26} strokeWidth={1.5} />
            <h2 className="mt-2 font-serif text-2xl text-[#0F1F17]">About the College</h2>
            <div className="mt-3 text-sm text-[#4D5A52] leading-relaxed" data-testid="ft-about-institute" dangerouslySetInnerHTML={{ __html: renderInstituteHtml((data.institute?.about_institute || "").trim() || STATIC_CONTENT.about_intro) }} />
          </div>
          <div className="space-y-5">
            <div className="bg-[#1F6B3F] text-white rounded-lg p-6">
              <Target size={22} strokeWidth={1.5} className="text-[#F4751F]" />
              <h3 className="mt-2 font-serif text-lg">Our Vision</h3>
              <div className="mt-2 text-[12px] text-white/85 leading-relaxed prose prose-invert prose-sm max-w-none" data-testid="ft-about-vision" dangerouslySetInnerHTML={{ __html: renderInstituteHtml((data.institute?.vision || "").trim() || STATIC_CONTENT.vision) }} />
            </div>
            <div className="bg-[#F4751F] text-white rounded-lg p-6">
              <Compass size={22} strokeWidth={1.5} className="text-white" />
              <h3 className="mt-2 font-serif text-lg">Our Mission</h3>
              <div className="mt-2 text-[12px] text-white/95 leading-relaxed prose prose-invert prose-sm max-w-none" data-testid="ft-about-mission" dangerouslySetInnerHTML={{ __html: renderInstituteHtml((data.institute?.mission || "").trim() || STATIC_CONTENT.mission) }} />
            </div>
          </div>
        </div>
      </PageBody>
    </div>
  );
}
